import React, { useState } from "react";
import { Avatar, Grid, IconButton, Popover, Typography } from "@mui/material";
import LillyLogo from "../../../../public/assets/lillyLogo.svg";
import { HOME } from "../../../constants/labels";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UserProfilePopup from "../../userProfilePopup/UserProfilePopup";
import { useMsal } from "@azure/msal-react";
import { clearUserInfo } from "../../../store/headerSlice";

export default function Header() {
  const [userProfileAnchor, setUserProfileAnchor] = useState(null);
  const userName = useSelector((state) => state.header.userName);
  const userNameChar = userName ? userName.charAt(0).toUpperCase() : "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance } = useMsal();

  const handleUserProfileClick = (event) => {
    setUserProfileAnchor(event.currentTarget);
  };

  const handleUserProfileClose = () => {
    setUserProfileAnchor(null);
  };

  const navigateToHomePage = () => {
    navigate("/create-project");
  };

  const handleLogout = () => {
    instance.logoutPopup().then(() => {
      dispatch(clearUserInfo());
      navigate("/logout");
    }).catch(e => {
      console.error(e);
    });
    handleUserProfileClose();
  };

  const openUserProfile = Boolean(userProfileAnchor);

  return (
    <Grid container className="header">
      <Grid item xs={3}>
        <div className="left_div" onClick={navigateToHomePage}>
          <span className="m2">
            <LillyLogo />
          </span>
          <Typography className="header_line m2">|</Typography>
          <Typography className="header_text m2">
            {HOME.TITLE}
          </Typography>
        </div>
      </Grid>
      {userName && (
        <Grid item xs={1}>
        <div className="right_div">
          <IconButton onClick={handleUserProfileClick}>
            <Avatar className="header_profile_text">{userNameChar}</Avatar>
          </IconButton>
        </div>
      </Grid>
      )}
      
      <Popover
        open={openUserProfile}
        anchorEl={userProfileAnchor}
        onClose={handleUserProfileClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <UserProfilePopup uname={userName} handleLogout={handleLogout} />
      </Popover>
    </Grid>
  );
};
